import React, { useState, useEffect } from "react";
import { setJourneyToken } from "@/lib/journeyToken";
import { useNavigate } from "react-router-dom";

import { navigationRules } from "@/b2b/config/partnerJourney";
import { getDataB2B } from "@/lib/helper";
import ProcessingScreen from "./processing";

export default function RedirectScreenHelper({ theme }) {
  const navigate = useNavigate();
  const userIdentifier = localStorage.getItem("user_identifier");
  const partner = localStorage.getItem("partnerIdentifier");

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const result = await getDataB2B(
          "b2b/onboard/pre-flight",
          userIdentifier
        );
        setJourneyToken(result.onboarding_token);
        let newStep;

        const isEligible = result?.data?.is_eligible;
        const panEligible = result?.data?.pan_eligible;
        const bankEligible = result?.data?.bank_eligible;

        if (isEligible)
          newStep =
            navigationRules[partner]?.isEligibleCongrats ||
            navigationRules.default.isEligibleCongrats;
        else if (isEligible === false)
          newStep =
            navigationRules[partner]?.notHardEligible ||
            navigationRules.default.notHardEligible;
        else {
          if (panEligible && !bankEligible)
            newStep =
              navigationRules[partner]?.bankingNotChecked ||
              navigationRules.default.bankingNotChecked;
          else if (!panEligible)
            newStep =
              navigationRules[partner]?.panNotChecked ||
              navigationRules.default.panNotChecked;
          else
            newStep =
              navigationRules[partner]?.notHardEligible ||
              navigationRules.default.notHardEligible;
        }
        navigate(`/b/${userIdentifier}?partner=${partner}&step=${newStep}`);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (userIdentifier) {
      fetchUserData();
    }
  }, [userIdentifier]);

  // Recoverable: the only thing this screen waits on is a pre-flight GET, and its catch merely logs
  // — so a failed fetch strands the tenant here permanently with nothing else to move them.
  return <ProcessingScreen theme={theme} recoverable />;
}
